import { Dispatch, SetStateAction, createContext, useContext } from 'react';

export type Spaces = 0 | 9 | 12 | 18 | 30 | 40;
export type StandType = 'unset' | 'standart' | 'individual' | 'premium';
export type StandBookingType = 'unset' | 'booked' | 'available';

export const MapStateContext = createContext<{
    space: Spaces;
    setSpace: Dispatch<SetStateAction<Spaces>>;
    type: StandType;
    setType: Dispatch<SetStateAction<StandType>>;
    bookingType: StandBookingType;
    setBookingType: Dispatch<SetStateAction<StandBookingType>>;
}>({
    space: 0,
    setSpace: () => {},
    type: 'unset',
    setType: () => {},
    bookingType: 'unset',
    setBookingType: () => {},
});

export const useMapStateContext = () => useContext(MapStateContext);
